<template>
  <svg class="ring-vector position-relative" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="ringGrad" gradientTransform="rotate(135 0.5 0.5)">
        <stop offset="0%" :stop-color="ringCols[0]"/>
        <stop offset="100%" :stop-color="ringCols[1]"/>
      </linearGradient>
    </defs>
    <circle
      class="ring-vect-circle"
      cx="100"
      cy="100"
      r="100"
      fill="none"
      stroke-width="1"
      stroke="url(#ringGrad)"
      stroke-dasharray="630"
      :stroke-dashoffset="dashOffset"
    />
  </svg>
</template>

<script>
  import StateMixin from '@/components/report/mixins/StateMixin'

  export default {
    name: 'RingVect',
    mixins: [ StateMixin ],
    props: {
      bg: String,
      cols: { type: Array, default () { return [] } },
      dashOffset: { type: Number, default () { return 0 } }
    },
    computed: {
      ringCols () {
        // default has to be handled here instead of props, since `colorsRev` is also a computed property
        return this.cols.length ? this.cols : this.colorsRev
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/svg/RingVect.vue